var App = App || {};

App.InstructionsBand = (function ($) {
    "use strict";

    function init() {
        const instructionsBand = $(".block.block-instructions-band");
        const activeClass = "active-step";

        if (instructionsBand.length) {
            instructionsBand.each(function () {
                var thisBand = $(this);
                //desktop default step navigation
                var stepButtons = $(this).find("button.step-intro");
                var stepContents = $(this).find(".step-content");
                //view toggles
                var showAllBtn = $(this).find(".btn.show-all");
                var showLessBtn = $(this).find(".btn.show-less");
                //mobile step navigation
                var stepNavBtns = $(this).find("button.step-nav");
                var stepNavPrev = $(this).find("button.step-nav.prev-button");
                var stepNavNext = $(this).find("button.step-nav.next-button");

                //let steps control content visibility
                stepButtons.each(function () {
                    $(this).on("click", function () {
                        var clickedButton = $(this);
                        var clickedId = clickedButton.attr("aria-controls");

                        stepButtons.removeClass(activeClass).attr("aria-expanded", false);
                        clickedButton.addClass(activeClass).attr("aria-expanded", true);

                        stepContents.removeClass(activeClass);
                        $("#" + clickedId).addClass(activeClass)
                    });
                });

                //mobile step navigation
                stepNavPrev.on("click", function () {
                    var currentStep = thisBand.find(".step-intro.active-step");
                    var currentStepId = currentStep.attr("aria-controls");
                    var currentStepContent = $("#" + currentStepId);

                    stepNavBtns.removeAttr("disabled");

                    if (currentStep.prev().hasClass("step-intro")) {
                        //move to previous step if this is not the first
                        currentStep.removeClass(activeClass).prev().addClass(activeClass);
                        currentStepContent.removeClass(activeClass).prev().addClass(activeClass);

                        //disable button if it is now the first
                        if (!currentStep.prev().prev().hasClass("step-intro")) {
                            stepNavPrev.prop("disabled", true);
                        }
                    }
                });

                stepNavNext.on("click", function () {
                    var currentStep = thisBand.find(".step-intro.active-step");
                    var currentStepId = currentStep.attr("aria-controls");
                    var currentStepContent = $("#" + currentStepId);

                    stepNavBtns.removeAttr("disabled");
                    
                    if (currentStep.next().hasClass("step-intro")) {
                        //move to next step if this is not the last
                        currentStep.removeClass(activeClass).next().addClass(activeClass);
                        currentStepContent.removeClass(activeClass).next().addClass(activeClass);

                        //disable button if it is now the last
                        if (!currentStep.next().next().hasClass("step-intro")) {
                            stepNavNext.prop("disabled", true);
                        }
                    } 
                });

                //transition between default & expanded views
                showAllBtn.on("click", function () {
                    thisBand.find(".instructions-inner.default-view").addClass("hidden");
                    thisBand.find(".instructions-inner.all-view").removeClass("hidden");

                    $('html, body').animate({
                        scrollTop: thisBand.offset().top
                    }, 100);
                });

                showLessBtn.on("click", function () {
                    thisBand.find(".instructions-inner.default-view").removeClass("hidden");
                    thisBand.find(".instructions-inner.all-view").addClass("hidden");

                    $('html, body').animate({
                        scrollTop: thisBand.offset().top
                    }, 100);
                });
            });
        }
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.InstructionsBand.init();
});